import React from 'react';

import './style.scss';
import { FormattedMessage } from 'react-intl';

interface IProps {
  logos: any[];
}

export class CarsLogos extends React.Component<IProps> {
  render(): React.ReactNode {
    const { logos } = this.props;

    return (
      <div className="cars-logos">
        <div className="container">
          <div className="cars-logos__wrapper">
            <p className="cars-logos__title secondary-font">
              <FormattedMessage id="cars.preferred.car.rental.companies" />
            </p>
            <div className="cars-logos__logos-wrapper">
              {logos.map((item, index) => (
                <div key={`${index}-${item.name}`}>
                  <div className="cars-logos__img-wrapper">
                    <img className="cars-logos__img" src={item.image} alt={item.name} />
                  </div>
                </div>
              ))}
            </div>
            </div>
          </div>
      </div>
    );
  }
}
